import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "i18n-fe";
import { acquireAppInstance, WINDOW_STATUS } from "../local/appInstanceLock";

// Card #3440. Renders `children` (the whole scoring app, including the
// ScoreProvider that starts the sync engine) only in the window that holds
// the app-instance lock. A newer window gets a full-screen notice and
// nothing else, and is promoted to the real app by itself the moment the
// first window is gone. No button, no dismiss: kiosk doctrine.
export default function SingleWindowGate({ children }) {
  const { t } = useTranslation("score");
  const [status, setStatus] = useState(WINDOW_STATUS.CHECKING);

  useEffect(() => acquireAppInstance(setStatus), []);

  if (status === WINDOW_STATUS.OWNER) return children;
  if (status === WINDOW_STATUS.CHECKING) return null;

  return (
    <Box
      data-testid="single-window-notice"
      role="alert"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        p: 4,
        textAlign: "center",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Typography variant="h4" component="h1">
        {t("singleWindow.title")}
      </Typography>
      <Typography variant="h6" component="p">
        {t("singleWindow.message")}
      </Typography>
    </Box>
  );
}
